var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header text-white bg-nav_header"},[_c('div',{staticClass:"header_title"},[_vm._v("WEBテスト "+_vm._s(_vm.caption))])])
}
var staticRenderFns = []

export { render, staticRenderFns }